/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online countdown timer and stopwatch with an alarm, plus one-click preset timers from 1 minute to 1 hour.`)
};

const es_timer_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador de cuenta regresiva y cronómetro online gratis con alarma, además de temporizadores predefinidos de un clic de 1 minuto a 1 hora.`)
};

const de_timer_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Countdown-Timer und Stoppuhr mit Alarm, plus Ein-Klick-Timer mit Voreinstellungen von 1 Minute bis 1 Stunde.`)
};

const nl_timer_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online afteltimer en stopwatch met alarm, plus eenklikstimers met vooraf ingestelde tijden van 1 minuut tot 1 uur.`)
};

const fr_timer_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuteur compte à rebours et chronomètre en ligne gratuits, avec alarme, plus des minuteurs prédéfinis en un clic de 1 minute à 1 heure.`)
};

const it_timer_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer countdown e cronometro online gratuiti con allarme, più timer preimpostati con un clic da 1 minuto a 1 ora.`)
};

const pt_br2_timer_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador e cronômetro online grátis com alarme, além de temporizadores predefinidos de um clique, de 1 minuto a 1 hora.`)
};

const pt_timer_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador de contagem decrescente e cronómetro online gratuitos, com alarme, além de temporizadores predefinidos de um clique, de 1 minuto a 1 hora.`)
};

const ja_timer_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アラーム付きの無料オンラインカウントダウンタイマー＆ストップウォッチ。1分から1時間まで、ワンクリックのプリセットタイマーも利用できます。`)
};

const zh_timer_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线倒计时器和秒表，带闹铃提醒，还有从1分钟到1小时的一键预设计时器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_tool_description", locale)
	if (locale === "en") return en_timer_tool_description(inputs)
	if (locale === "es") return es_timer_tool_description(inputs)
	if (locale === "de") return de_timer_tool_description(inputs)
	if (locale === "nl") return nl_timer_tool_description(inputs)
	if (locale === "fr") return fr_timer_tool_description(inputs)
	if (locale === "it") return it_timer_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_timer_tool_description(inputs)
	if (locale === "pt") return pt_timer_tool_description(inputs)
	if (locale === "ja") return ja_timer_tool_description(inputs)
	return zh_timer_tool_description(inputs)
};